import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.popstateHandler = (event) => this.onPopstate(event)
    window.addEventListener("popstate", this.popstateHandler)

    this.frameLoadHandler = (event) => this.onFrameLoad(event)
    document.addEventListener("turbo:frame-load", this.frameLoadHandler)

    this.ensureInterceptState()
  }

  disconnect() {
    if (this.popstateHandler) {
      window.removeEventListener("popstate", this.popstateHandler)
    }

    if (this.frameLoadHandler) {
      document.removeEventListener("turbo:frame-load", this.frameLoadHandler)
    }
  }

  ensureInterceptState() {
    try {
      if (history.state && history.state.bpPitchRoundBackConfirm) return
      history.pushState({ ...(history.state || {}), bpPitchRoundBackConfirm: true }, "", window.location.href)
    } catch (e) {}
  }

  onPopstate(event) {
    try {
      this.ensureInterceptState()
    } catch (e) {}

    if (!this.openConfirmModal()) {
      this.pendingOpen = true
    }
  }

  onFrameLoad(event) {
    if (!this.pendingOpen) return
    if (!event || !event.target || event.target.id !== "matches") return

    this.pendingOpen = false

    window.requestAnimationFrame(() => {
      this.openConfirmModal()
    })
  }

  openConfirmModal() {
    const dialog = document.getElementById("freebie-confirm-modal")
    if (dialog && dialog.open === true) {
      return true
    }

    const trigger = document.getElementById("freebie-cta")
    if (trigger) {
      trigger.click()
      return true
    }

    if (dialog && typeof dialog.showModal === "function") {
      try {
        dialog.showModal()
        return true
      } catch (e) {
        return false
      }
    }

    return false
  }
}
